/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Engineering_And_Technology24Inputs */

const en_job_form_enum_engineering_and_technology24 = /** @type {(inputs: Job_Form_Enum_Engineering_And_Technology24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engineering and Technology`)
};

const de_job_form_enum_engineering_and_technology24 = /** @type {(inputs: Job_Form_Enum_Engineering_And_Technology24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingenieurwesen und Technologie`)
};

/**
* | output |
* | --- |
* | "Engineering and Technology" |
*
* @param {Job_Form_Enum_Engineering_And_Technology24Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_engineering_and_technology24 = /** @type {((inputs?: Job_Form_Enum_Engineering_And_Technology24Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Engineering_And_Technology24Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_engineering_and_technology24(inputs)
	return en_job_form_enum_engineering_and_technology24(inputs)
});
export { job_form_enum_engineering_and_technology24 as "job_form_enum_ENGINEERING_AND_TECHNOLOGY" }